import React from "react";
import "./index.scss";

import { duration } from "utils";
// ui
import { Button } from "antd";
// animations
import { Fade } from "react-reveal";

// components
import PublicOffering from "../PublicOffering";

// images
import Logo from "../../../assets/icons/logo-ic-larget.svg";
import RightIcon from "../../../assets/icons/ic-right.svg";
import PDF from "assets/docs/lightpaper.pdf";

const Banner = (props) => {
  const timeFormat = "DD-MM-YYYY, HH:mm:ss";
  const timeTillDate = "30-09-2021, 00:00:00";

  return (
    <div className="bannerLanding">
      <div className="bannerContent">
        <div className="contentLeft">
          <Fade bottom duration={duration}>
            <div className="viewLogo">
              <img src={Logo} alt="" />
              <p>Precog</p>
            </div>
          </Fade>
          <Fade bottom duration={duration}>
            <div className="viewIcon">
              <img src={RightIcon} alt="" />
            </div>
          </Fade>
        </div>

        <Fade bottom duration={duration}>
          <div className="contentRight">
            <p>Futures ecosystem and automated basis trade aggregator. </p>

            <div className="actions">
              <Button href={PDF} target="_blank">
                Lightpaper
              </Button>
              {/* <Button onClick={props.viewRoadMap}>Roadmap</Button> */}
            </div>
          </div>
        </Fade>
      </div>

      <PublicOffering timeFormat={timeFormat} timeTillDate={timeTillDate} />
    </div>
  );
};

export default Banner;
